<script lang="ts" context="module">
    import { writable } from "svelte/store"
    import type { FootnotesClass } from "@circleofa/acim-engine"
    import { navigatorWidth } from "@components/navigator/Navigator.svelte"
    import { styleFontSize } from "@store/deviceSettings"

    export function openFootnote(number: number) {
        footnote.set(number)
    }

    // @ts-ignore
    // need this because openfootnote button is rendered through dynamic html call
    // (see how footnote links are processed in DisplayWord creation)
    window.openFootnote = openFootnote
    export const footnote = writable<number | null>(null)
    export const footnotes = writable<FootnotesClass | null>(null)
</script>

<script lang="ts">
    import { onDestroy, onMount } from "svelte"
    import { slide } from "svelte/transition"
    import Icon from "@components/material/Icon.svelte"
    import { clickEnter } from "@utils/directives/accessibility"
    import { connectCourseReferenceButtons } from "@utils/reading/render"
    import { ALLOW_CONTEXT_MENU_CLASS } from "@utils/underhood/disable-context-menu"
    import { NATIVE_SELECTION_REGION_CLASS } from "@utils/highlights/directive-logic/native-selection-bridge"
    import { twMerge } from "tailwind-merge"
    const duration = 300

    let showFootnote: number | null = null
    let lastFootnote: number | null = null
    $: showLogic($footnote)
    function showLogic(footnote: number | null) {
        if (!lastFootnote || !footnote) {
            showFootnote = footnote
            lastFootnote = footnote
            next = () => {}
            return
        }

        // Otherwise, we're changing, so we want a nice transition
        showFootnote = null
        lastFootnote = null
        next = () => {
            showFootnote = footnote
            lastFootnote = footnote
        }
    }

    let next: () => void = () => {}
    let closed = true

    let className = ""
    export { className as class }
    export let framedTopClearance = "0px"
</script>

{#if showFootnote && $footnotes}
    <div
        class={twMerge("footnote", className)}
        class:closed
        style:--reader-frame-header-height={framedTopClearance}
        on:outrostart={() => (closed = true)}
        on:introstart={() => (closed = false)}
        transition:slide={{ duration }}
        on:outroend={next}
    >
        <div
            class="close"
            role="button"
            tabindex={0}
            on:keydown={clickEnter}
            aria-label="close footnote"
            on:click={() => ($footnote = null)}
        >
            <Icon icon="close-sm" />
        </div>
        <div class="fuzz" />
        <div class="fuzz bottom" />
        <div class="innerFootnote">
            <!-- Responsive from styles.css -->
            <div
                class="footnoteContent {ALLOW_CONTEXT_MENU_CLASS} {NATIVE_SELECTION_REGION_CLASS}"
                use:styleFontSize
                style:padding-left={`max(1rem, calc(2rem + ${$navigatorWidth}px))`}
            >
                <span class="footnoteNumber">{showFootnote}.</span>
                {@html connectCourseReferenceButtons($footnotes.processFootnote(showFootnote))}
                <div class="bottomSpacer" />
            </div>
        </div>
    </div>
{/if}

<style>
    .footnoteContent {
        -webkit-user-select: text;
        user-select: text;
    }
</style>
